import AuthenticationProvider from 'contexts/authentication.context';
import { PermissionsProvider } from 'contexts/Permissions.context';
import { RootStoreProvider } from 'contexts/RootStore.context';
import { ErrorBoundary as SystemErrorBoundary } from 'react-error-boundary';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import SystemErrorPage from 'views/SystemErrorPage';
import ErrorBoundary from 'wrappers/ErrorBoundary';
import PublicConfigWrapper from 'wrappers/PublicConfigWrapper';
import routes from './routes';
import { Layout } from 'components/Navigation/Layout';
import AmplifyRefreshTimer from 'components/AmplifyRefreshTimer';
import { NotificationProvider } from 'contexts/notification.context';
import { Announcer } from 'components/Announcer';

export default function AppRouter() {
  return (
    <BrowserRouter>
      <SystemErrorBoundary fallback={<SystemErrorPage />}>
        <PublicConfigWrapper>
          <AuthenticationProvider>
            <RootStoreProvider>
              <NotificationProvider>
                <Announcer />
                <Routes>
                  {routes.map((route) =>
                    <Route
                      key={route.url}
                      path={route.url}
                      element={
                        <PermissionsProvider>
                          <AmplifyRefreshTimer />
                          <ErrorBoundary>
                            <Layout route={route} />
                          </ErrorBoundary>
                        </PermissionsProvider>
                      }
                    />
                  )}
                </Routes>
              </NotificationProvider>
            </RootStoreProvider>
          </AuthenticationProvider>
        </PublicConfigWrapper>
      </SystemErrorBoundary>
    </BrowserRouter>
  );
}
